import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  searchInstallment,
  downloadInstallmentIncomeDetail,
} from '../../redux/actions/projectBasedItems'
import {
  sessionSetItemObj,
  sessionGetItemStr,
  sessionGetItemJSON,
} from '../../utils/sessionHelpers'
import VoucherListTable from './VoucherListTable'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj, sessionRemoveItem } from '../../utils/sessionHelpers'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'
import MiniProjectInfo from './MiniProjectInfo'
import { downloadCheckFile, getExpensesCheckList } from '../../redux/actions/accountingExpenses'
import CheckVoucherListTable from './CheckVoucherListTable'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadFile } from '../../utils/fileUtil'

export default function CheckVoucherListWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const history = useHistory()

  const projectCode = sessionStorage.getItem('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const handleSearch = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getExpensesCheckList(request, projectCode, periodNumber)
      // console.log('resssss 99999 ', response)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelect = (rowData, type) => {
    sessionSetItemObj('checkData', { id: rowData?.id, editMode: type == 'edit' })

    history.push({
      pathname: pathname.incomeAndExpense.ExpenseCheckManage,
    })
  }

  const handleOnExport = async (data) => {
    console.log('handleOnExport ', data)
    // console.log('Test handleOnExport ')
    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadCheckFile(projectCode, periodNumber)
      console.log('file ', file)
      if (file) {
        downloadFile(file, `ทะเบียนเช็ค_${projectCode}.pdf`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
      >
        {formSchema?.projectInfo && (
          <>
            <MiniProjectInfo schema={formSchema.projectInfo} />
            <br />
          </>
        )}

        <CheckVoucherListTable
          schema={formSchema.form}
          Controller={Controller}
          control={control}
          pagination={true}
          loading={isLoading}
          onSelect={handleSelect}
          onSearch={(req) => {
            handleSearch(req)
          }}
          onCancel={(req) => {
            handleSearch({})
          }}
          onClick={handleOnExport}
          disableForm={formSchema.disabled}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
